import React, { useEffect, useRef, useState } from 'react';

import { createFilterOptions, TextField, Typography } from '@mui/material';

import { CrossIcon } from 'packages/icons-svg';

import StyledAutocomplete from './StyledAutocomplete';

import './index.scss';

const DupontDropdown = props => {
  let {
    value,
    options,
    getOptionLabel,
    disabled,
    onChange,
    onInputChange,
    placeholder,
    errorMsg,
    labelText,
    renderOption,
    onInputBlur,
    inputAdornment,
    customClass,
    ismultiple,
    groupBy,
    getOptionSelected,
    dropdownRef,
    tagSearchLabel,
  } = props;

  const MAX_DROPDOWN_OPTIONS = options?.length || 1000;
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);
  customClass = customClass || '';
  options = options || [];
  const dropdownId = 'dropdown'; //getControlId(labelText, 'dropdown');

  useEffect(() => setOpen(false), []);
  const openDropdownPopup = () => setOpen(!disabled);

  const clearIconHandler = () => {
    if (!disabled) {
      const input = inputRef.current;
      const lastValue = input.value;

      input.value = '';
      const event = new Event('input', { bubbles: true });
      const tracker = input._valueTracker;
      if (tracker) {
        tracker.setValue(lastValue);
      }
      input.dispatchEvent(event);
      if (onInputChange) {
        onInputChange('', 'clear');
      }
      if (onChange) {
        onChange('', 'clear');
      }
      openDropdownPopup();
    }
  };

  const onValChange = (event, newValue, reason) => {
    if (onChange) {
      onChange(newValue, reason);
    }
    setOpen(false);
  };

  const onInputValChange = (event, newValue, reason) => {
    if (onInputChange) {
      onInputChange(newValue, reason);
    }

    if (reason === 'input') {
      openDropdownPopup();
    }
  };

  const onClickListener = () => setOpen(!open && !disabled);

  const onBlur = event => {
    setOpen(false);
    if (onInputBlur) {
      onInputBlur(event);
    }
  };

  const getLabel = option => {
    let label = option;
    if (getOptionLabel) {
      label = getOptionLabel(option) || '';
    }
    return label;
  };

  const inputEndAdornment = newValue => {
    if (newValue) {
      return {
        endAdornment: (
          <div className='pointer' style={{ height: '32px' }} onClick={clearIconHandler}>
            {newValue ? <CrossIcon disabled={disabled} /> : null}
          </div>
        ),
      };
    }
  };

  const renderDropdownInput = params => {
    const inputVal = params.inputProps.value;
    const adorment = inputVal && inputAdornment ? inputAdornment(inputVal) : {};
    return (
      <TextField
        inputRef={inputRef}
        {...params}
        InputProps={{
          ...params.InputProps,
          ...adorment,
          ...inputEndAdornment(inputVal),
          disableUnderline: true,
        }}
        onBlur={onBlur}
        error={Boolean(errorMsg)}
        placeholder={placeholder}
      />
    );
  };
  const renderTags = selected => {
    const renderValue = selected.join(', ');
    return <Typography>{renderValue}</Typography>;
  };

  const getDropdownClasses = () => {
    let styles = '';
    if (open) {
      styles = `drop-down__input--focus`;
    }
    if (errorMsg) {
      styles = ` drop-down__input--error`;
    }
    return styles;
  };

  const getSearchLabel = option => (typeof tagSearchLabel === 'function' ? tagSearchLabel(option) : getLabel(option));

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    limit: MAX_DROPDOWN_OPTIONS,
    stringify: option => getSearchLabel(option),
  });

  return (
    <>
      <div className={` ${getDropdownClasses()} ${customClass}`}>
        {labelText && (
          <label className={`dupont-form-label wrapText`} disabled={disabled}>
            {labelText}
          </label>
        )}
        <div className='dropdown-container' id={dropdownId + '_container'} onClick={onClickListener}>
          <StyledAutocomplete
            id={dropdownId}
            open={open}
            // popupIcon={<DownIcon />}
            closeIcon=''
            filterOptions={filterOptions}
            ref={dropdownRef}
            multiple={ismultiple}
            disabled={disabled}
            value={value || null}
            onChange={onValChange}
            options={options}
            getOptionLabel={getLabel}
            renderInput={renderDropdownInput}
            onInputChange={onInputValChange}
            renderTags={renderTags}
            getOptionSelected={getOptionSelected}
            groupBy={groupBy}
            renderOption={renderOption}
          />
        </div>
      </div>
    </>
  );
};

export default DupontDropdown;
